let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3zwqj")).then(() => parcelRequire('5Y0Qa'));